module.exports = __webpack_public_path__ + "img/media-web.26240488.svg";